// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-q_gj","advertDetailServiceList__header":"c-q_gk","advertDetailServiceList__list":"c-q_gl"};